module.exports = __webpack_public_path__ + "static/media/icon_nosotros_privado.c5be7158.svg";